import React from "react";
import { bindActionCreators } from "redux";
import fetchConfigAction from "../../actions/fetchConfig";
import { connect } from "react-redux";

class Config extends React.Component {
  componentDidMount() {
    this.props.fetchConfig();
  }

  render() {
    return this.props.children;
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchConfig: fetchConfigAction
}, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(Config);


// WEBPACK FOOTER //
// ./src/components/common/Config.js